import { getPaddleEnvironment } from "@/lib/paddle";

export function PaymentTestModeBanner() {
  if (getPaddleEnvironment() !== "sandbox") return null;
  return (
    <div className="w-full bg-amber-500/15 border-b border-amber-500/40 px-4 py-2 text-center text-xs text-amber-200">
      Payments are in <strong>test mode</strong>. Use card 4242 4242 4242 4242 to try a checkout — no real charges.{" "}
      <a
        href="https://docs.lovable.dev/features/payments#test-and-live-environments"
        target="_blank"
        rel="noopener noreferrer"
        className="underline font-medium"
      >
        Learn more
      </a>
    </div>
  );
}